import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import { BrieConversation } from "../../../components/BrieChatMenu/BrieMessages";
import BrieConversationAPI from "../../api/BrieConversationAPI";

interface UseConversation {
  conversation: BrieConversation;
  conversationLoading: boolean;
}

const useConversation = (conversationID: string, enabled: boolean = true) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const conversation = useQuery({
    queryKey: ["conversation", conversationID],
    queryFn: () =>
      BrieConversationAPI.getGPTConversationByID(conversationID).then(
        (data) => data.data.data.conversation
      ),
    enabled:
      !!conversationID && queriesEnabled && enabled && conversationID !== "new",
  });

  const result: UseConversation = {
    conversation: conversation.data,
    conversationLoading:
      (conversation.isLoading || queriesEnabled === false) &&
      conversationID !== "new",
  };

  return result;
};

export default useConversation;
